(() => {
  const home = document.querySelector('.ciprio-exact-home');
  if (home) document.body.classList.add('ciprio-home-active');

  const toggle = document.querySelector('[data-ciprio-menu-toggle]');
  const menu = document.querySelector('[data-ciprio-mobile-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
  }
})();